import { createSlice } from "@reduxjs/toolkit";

const signoutSlice = createSlice({
  name: "signout",
  initialState: {
    signOutStatus: false,
  },
  reducers: {
    toggleSignOutStatus: (state, action) => {
      state.signOutStatus = action.payload;
    },
  },
});

export const { toggleSignOutStatus } = signoutSlice.actions;
export default signoutSlice.reducer;
